import React from 'react';
import { NotificationImportant } from '@insurancemenu/imenu-components-lib/dist/icons';
import { colors } from '@insurancemenu/imenu-components-lib';
import { InfoBlobWrapper, MessageStyled, TitleStyled } from './styles';

const InfoBlob: React.FC = () => {
  return (
    <InfoBlobWrapper>
      <NotificationImportant width="5rem" height="5rem" color={colors.green[600]} />
      <TitleStyled>Further actions note</TitleStyled>
      <MessageStyled>
        Here you can review the list of carriers based on your selection on the previous page. A separate checklist will
        be created for each carrier. You will need to complete all the checklists to proceed with the proposal.
      </MessageStyled>
    </InfoBlobWrapper>
  );
};

export default InfoBlob;
